(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/core/assets/javascripts/events/constants.js') >= 0) return;  svs.modules.push('/components/onboarding/core/assets/javascripts/events/constants.js');
"use strict";

const FullscreenEventType = {
  Show: 'fullscreenOnboardingShow',
  Hide: 'fullscreenOnboardingHide'
};
const TooltipEventType = {
  Add: 'tooltipAdd',
  Created: 'tooltipCreated',
  Delete: 'tooltipDeleted',
  Removed: 'tooltipRemoved'
};
const _exports = {
  FullscreenEventType,
  TooltipEventType
};
setGlobal('svs.components.onboarding.core.events.constants', _exports);

 })(window);